import { appConstants } from "../constants/appConstants"

const initialState = { counter: 0 }

const loaderReducer = (state: any = initialState, action: any): any => {
  switch (action.type) {
    case appConstants.INCREMENT_COUNTER:
      return { counter: state.counter + 1 }
    case appConstants.DECREMENT_COUNTER:
      return { counter: state.counter > 0 ? state.counter - 1 : 0 }
    case appConstants.RESET:
      return { ...initialState }
    default:
      return state
  }
}

export default loaderReducer
